import AssetType from 'common/enums/assetTypes';
import { useDispatch } from 'react-redux';
import { setDiscounts } from 'redux/slices/discountSlice';
import { setExpandAccordionEdited } from 'redux/slices/eventSlice';
import DiscountForm from './DiscountForm';

const EventDiscountsEdit = (props) => {
    const { closeForm, discount, discounts, idx } = props;

    const dispatch = useDispatch();

    const setEditedDiscount = (editedDiscount) => {
        let newArr = [...discounts];
        newArr[idx] = editedDiscount;
        dispatch(setDiscounts(newArr));
        dispatch(setExpandAccordionEdited(AssetType.DISCOUNT));
        closeForm();
    };

    return (
        <DiscountForm
            discount={discount}
            onSubmit={(e) => {
                setEditedDiscount(e);
            }}
            onClose={() => {
                closeForm();
            }}
        />
    );
};

export default EventDiscountsEdit;
